/**
 * Classification and formatting for downloadable gateway firmware artifacts.
 *
 * Split out from the component that renders them so both the downloads UI and
 * the firmware-version dialog can import these without tripping fast refresh.
 */

type FirmwareArtifactType = 'iso' | 'ova';

export function classifyFirmwareFile(filename: string): FirmwareArtifactType | null {
  const name = filename.toLowerCase();
  const dot = name.lastIndexOf('.');
  const ext = dot >= 0 ? name.substring(dot + 1) : '';
  if (ext === 'iso') return 'iso';
  // The OVA is self-contained (OVF, manifest and disk in one tar).
  if (ext === 'ova') return 'ova';
  return null;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${String(bytes)} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}
